<div class="upload-file-btn" [class.invalid]="validStatus === false && !file">
  <button type="button" mat-raised-button class='capitalize' color='accent' (click)="uploadCroppImg()">{{title}}
  </button>
  <span class="required" *ngIf="required">*</span>
</div>
